import {JavaAPIClient} from "../lib/apiHelper";

const { get, post, put, remove } = new JavaAPIClient();

export default {
	add: (resyday) => post('/restday', resyday),
    modify: (resyday) => put('/restday', resyday),
    delete: (id) => remove('/restday?id=' + id),
    getUserStateRestList: (search) => get('/restday/getUserStateRestList?' + (search ? new URLSearchParams(search).toString() : '')),
    /**
     * 휴가종류 상태 (사용/미사용)
     * @param {{ id: number, restActiveStatus: boolean }} restday
     */
    updateRestStatus: (restday) => put('/restday/updateStatus', restday),
};